import React from 'react';
import { Grid, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';

const UserAllyCourses = (props) => {
    const { data, classes } = props;
    return (
        <React.Fragment>
            <Grid item xs={12}>
                <Typography variant="subtitle1"><b>Aliados</b></Typography>
                <hr />
            </Grid>
            {data && data.courses && data.courses.map(courses => (
                <React.Fragment key={`rf_courses_ally_${courses.id}`}>
                    <Grid item xs={12}>
                        <Typography color="primary" className={classes.textDecorationUnderline}>{courses.name}</Typography>
                    </Grid>
                    {courses.courses.map(course => (
                        <Table key={`table_course_ally_${course.course_id}`}>
                            <TableBody>
                                <TableRow>
                                    <TableCell width="30%" className={`${classes.borderNone} ${classes.valignTop}`}>
                                        <Typography variant="body2" className="mt-1">{course.name}</Typography>
                                        <Typography variant="caption" color="textSecondary">{`id: ${course.course_id}`}</Typography>
                                    </TableCell>
                                    <TableCell width="70%" className={classes.borderNone}>
                                        <li className={`${classes.ul_li_list} ml-4`}><Typography variant="caption">{`source_id: ${course.source_id}`}</Typography></li>
                                        <li className={`${classes.ul_li_list} ml-4`}><Typography variant="caption">{`course_url: ${course.course_url}`}</Typography></li>
                                        <li className={`${classes.ul_li_list} ml-4`}><Typography variant="caption">{`third_party_id: ${course.third_party_id}`}</Typography></li>
                                        <li className={`${classes.ul_li_list} ml-4`}><Typography variant="caption">{`modality_id: ${course.modality_id === 1 ? 'Presencial' : 'Online'}`}</Typography></li>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    ))}
                </React.Fragment>
            ))}
        </React.Fragment>
    )
};

export default UserAllyCourses;